<h3 class="u-font-size-20 u-margin-bottom-quarter">{{ 'ADMIN.DASHBOARD.CONTACT_US.TITLE' | translate }}</h3>
<p class="u-color-gray-darkest u-font-weight-normal u-margin-bottom">{{ 'ADMIN.DASHBOARD.CONTACT_US.SUB_TITLE' | translate }}</p>

<app-contact-us [contactUsLinks]="contactUsLinks"></app-contact-us>
